import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dice5, ListChecks, Link2, ShieldCheck, ShieldAlert } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
import { getStats } from "@/lib/api";
import { TIPO_LABEL, isVisibleTipo } from "@/lib/format";

export default function Overview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { getStats().then(setStats).catch(() => {}); }, []);

  const cards = stats ? [
    { label: "Sorteos totales", value: stats.total_sorteos, icon: ListChecks },
    { label: "Juegos configurados", value: stats.total_juegos, icon: Dice5 },
    { label: "Registros en bitácora", value: stats.total_registros_ledger, icon: Link2 },
  ] : [];

  const chartData = stats ? Object.entries(stats.por_tipo).filter(([k]) => isVisibleTipo(k)).map(([k, v]) => ({ tipo: TIPO_LABEL[k] || k, sorteos: v })) : [];

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-bold">Resumen</h1>
          <p className="text-sm text-muted-foreground">Estado general del sistema de sorteos.</p>
        </div>
        <Link to="/consola/sorteos" className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground">Nuevo sorteo</Link>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Card key={c.label}><CardContent className="p-5">
            <div className="flex items-center justify-between"><span className="text-sm text-muted-foreground">{c.label}</span><c.icon className="h-4 w-4 text-primary" /></div>
            <p className="mt-2 font-display text-3xl font-bold" data-testid={`stat-${c.label}`}>{c.value}</p>
          </CardContent></Card>
        ))}
        {stats && (
          <Card className={stats.cadena_integra ? "border-success/40" : "border-destructive/40"}>
            <CardContent className="p-5">
              <div className="flex items-center justify-between"><span className="text-sm text-muted-foreground">Integridad de la cadena</span>
                {stats.cadena_integra ? <ShieldCheck className="h-4 w-4 text-success" /> : <ShieldAlert className="h-4 w-4 text-destructive" />}</div>
              <p className="mt-2 font-display text-xl font-bold" data-testid="stat-chain">{stats.cadena_integra ? "Íntegra" : "Comprometida"}</p>
            </CardContent>
          </Card>
        )}
      </div>

      <Card className="mt-6">
        <CardHeader><CardTitle className="font-display text-lg">Sorteos por tipo de juego</CardTitle></CardHeader>
        <CardContent>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <XAxis dataKey="tipo" tickLine={false} axisLine={false} fontSize={12} />
                <YAxis allowDecimals={false} tickLine={false} axisLine={false} fontSize={12} />
                <Tooltip />
                <Bar dataKey="sorteos" fill="hsl(var(--primary))" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
